import { Chart } from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';
export default class EduChart {

    constructor(el) {
        if (!(el && el.nodeName === "CANVAS")) {
            return;
        }

        const data = el.getAttribute('data-chart-values');
        if (!data) {
            return;
        }

        this.container = el;
        this.data = JSON.parse(data);

        this.init();
    }

    init() {

        window.addEventListener('load', () => {
            const context = this.container.getContext('2d');
            const labels = this.data.map(c => c.label);

            // Register the plugin to all charts:
            Chart.register(ChartDataLabels);

            Chart.register({
                id: 'customLabelsPlugin', // L�gg till ett unikt id f�r pluginet
                afterDraw: function (chart) {
                    const { ctx } = chart;
                    let i = 0;

                    for (const label of labels) {
                        const meta = chart.getDatasetMeta(0).data[i++];
                        const x = chart.scales.x.getPixelForValue(0); // X-axelns startposition
                        const y = meta.y - 24; // Centrera etiketten i h�jdled p� stapeln

                        ctx.fillStyle = '#152938'; // F�rg p� texten
                        ctx.font = '500 14px Gesta'; // Stil och storlek p� texten
                        ctx.textAlign = 'start';
                        ctx.textBaseline = 'middle';

                        ctx.fillText(label.toUpperCase(), x, y);
                    }
                },
                beforeDatasetsDraw: function (chart) {
                    const { ctx, data, chartArea: { left, right }, scales: { y } } = chart
                    ctx.save();

                    const dataset = data.datasets[0];
                    const cornerRadius = 20;
                    const halfBarHeight = dataset.barThickness * 0.5;

                    for (let i = 0; i < dataset.data.length; i++) {
                        const yPos = y.getPixelForValue(i);
                        ctx.beginPath();
                        ctx.fillStyle = 'rgba(71, 109, 136, 0.14)';
                        ctx.moveTo(left + cornerRadius, yPos - halfBarHeight);
                        ctx.arcTo(left, yPos - halfBarHeight, left, yPos + halfBarHeight, cornerRadius);
                        ctx.arcTo(left, yPos + halfBarHeight, right, yPos + halfBarHeight, cornerRadius);
                        ctx.arcTo(right, yPos + halfBarHeight, right, yPos - halfBarHeight, cornerRadius);
                        ctx.arcTo(right, yPos - halfBarHeight, left, yPos - halfBarHeight, cornerRadius);
                        ctx.closePath();
                        ctx.fill();
                    }
                }
            });

            new Chart(context, {
                type: 'bar',
                data: {
                    labels,
                    datasets: [{
                        data: this.data.map(c => c.value),
                        backgroundColor: ['#476D88'],
                        borderColor: ["rgba(71, 109, 136, 0.14)"],
                        barThickness: 30,
                        barThickness: 30,
                        borderWidth: 0,
                        borderSkipped: false,
                        borderRadius: 50,
                    }]
                },
                options: {
                    indexAxis: 'y',
                    responsive: true,
                    maintainAspectRatio: false,
                    animation: false,
                    plugins: {
                        tooltip: {
                            enabled: false
                        },
                        legend: {
                            display: false,
                        },
                        datalabels: {
                            color: '#152938',
                            anchor: 'end',
                            align: 'end',
                            offset: 2,
                            formatter: function (value) {
                                return value.toFixed(2).replace(/[.,]?0*$/, '') + '%';
                            },
                            display: 'auto',
                            borderRadius: [50, 50, 50, 50],
                            borderWidth: 1,
                            font: {
                                size: 14,
                                family: "Gesta",
                                weight: 500

                            },
                            padding: {
                                top: .5, 
                                bottom: .5
                            },
                            clip: true,
                            borderSkipped: 'left',
                            position: 'end'
                        },
                    },
                    scales: {
                        x: {
                            beginAtZero: true,
                            max: 100,
                            display: false,
                        },
                        y: {
                            display: false,
                        },
                    },
                },

                plugins: [ChartDataLabels]
            });

            //Add dynamic height for container
            const chartHeight = 250;
            const totalBars = labels.length;
            const chartContainer = document.querySelector(".chart-container");

            if (chartContainer && totalBars > 4) {
                const newHeight = (totalBars - 4) * 63 + chartHeight;
                chartContainer.style.height = newHeight + 'px';
            }
        });
    }
}
